import { axiosInstanceV1 } from "@bn/api";

export const userResetPassword = async ({ email }: { email: string }) => {
  const { data } = await axiosInstanceV1.post<undefined>(
    `/users/initiatePasswordReset`,
    null,
    { params: { email } }
  );
  return data;
};
